import { render, staticRenderFns } from "./NovoConvite.vue?vue&type=template&id=3bddd74d&scoped=true&"
import script from "./NovoConvite.vue?vue&type=script&lang=js&"
export * from "./NovoConvite.vue?vue&type=script&lang=js&"
import style0 from "./NovoConvite.vue?vue&type=style&index=0&id=3bddd74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddd74d",
  null
  
)

export default component.exports